module.exports = __webpack_public_path__ + "img/eye-slash.4e989b18.svg";